<template>
  <div class="std-project-edit-page">
    <div v-if="loading" class="page-loading" v-loading="true"></div>

    <el-result v-else-if="loadError" icon="error" title="项目加载失败" :sub-title="loadError">
      <template slot="extra">
        <el-button type="primary" @click="loadPage">重新加载</el-button>
      </template>
    </el-result>

    <template v-else-if="loaded">
      <div v-if="lastSubmitResult" class="submit-result-list">
        <el-alert
          v-if="lastSubmitResult.project_update"
          :title="projectSubmitResultTitle"
          :type="lastSubmitResult.project_update.success ? 'success' : 'error'"
          show-icon
          :closable="false"
        ></el-alert>
        <el-alert
          v-if="lastSubmitResult.materials_sync"
          :title="materialSubmitResultTitle"
          :type="lastSubmitResult.materials_sync.success ? 'success' : 'error'"
          show-icon
          :closable="false"
        ></el-alert>
      </div>

      <StandardProjectForm ref="projectFormRef" :form="form" @update:form="onFormUpdate"></StandardProjectForm>
    </template>

    <div class="ad-submit">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" :disabled="submitDisabled" :loading="submitLoading" @click="onSubmit">确认提交</el-button>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { Message, MessageBox } from 'element-ui'
import StandardProjectForm from './components/StandardProjectForm.vue'
import { useStdProjectEdit } from './hooks/useStdProjectEdit.js'

const query = new URLSearchParams(window.location.search)
const accountId = query.get('accountId') || ''
const projectId = query.get('projectId') || ''
const projectFormRef = ref(null)

const {
  form,
  loading,
  submitLoading,
  loadError,
  lastSubmitResult,
  loaded,
  submitDisabled,
  load,
  submit
} = useStdProjectEdit({ accountId, projectId })

const projectSubmitResultTitle = computed(() => {
  const result = lastSubmitResult.value
  if (!result) return ''
  return result.project_update
    ? `项目信息：${result.project_update.success ? '成功' : '失败'}，${result.project_update.msg || '-'}`
    : '项目信息：未执行'
})
const materialSubmitResultTitle = computed(() => {
  const result = lastSubmitResult.value
  if (!result) return ''
  return result.materials_sync
    ? `素材同步：${result.materials_sync.success ? '成功' : '失败'}，${result.materials_sync.msg || '-'}`
    : '素材同步：未执行'
})
const submitResultTitle = computed(() => `${projectSubmitResultTitle.value}；${materialSubmitResultTitle.value}`)

function onFormUpdate(nextForm) {
  form.value = nextForm
}

async function loadPage() {
  if (!accountId || !projectId) {
    Message.error('缺少 accountId 或 projectId')
    return
  }
  try {
    await load()
  } catch (e) {
    Message.error(e.message || '项目加载失败')
  }
}

async function onSubmit() {
  let requestStarted = false
  try {
    await projectFormRef.value.validate()
    requestStarted = true
    const result = await submit()
    const success = Boolean(result.project_update?.success && result.materials_sync?.success)

    if (success) {
      Message.success('项目修改成功')
      window.close()
      return
    }

    await load()
    await MessageBox.alert(submitResultTitle.value, '部分操作未成功', {
      confirmButtonText: '知道了',
      type: 'warning'
    })
  } catch (e) {
    if (e === 'cancel' || e === 'close') return
    if (requestStarted) {
      try {
        await load()
      } catch (loadException) {}
    }
    Message.error(e.message || '项目修改失败')
  }
}

async function onCancel() {
  try {
    await MessageBox.confirm('当前修改尚未提交，确定关闭页面吗？', '提示', {
      confirmButtonText: '确定关闭',
      cancelButtonText: '继续编辑',
      type: 'warning'
    })
    window.close()
  } catch (e) {}
}

onMounted(loadPage)
</script>

<style lang="scss" scoped>
.std-project-edit-page {
  min-height: calc(100vh - 64px);
  background: #f5f7fa;
}

.page-loading {
  height: calc(100vh - 64px);
}

.submit-result-list {
  width: calc(100% - 40px);
  margin: 16px 20px 0;
}

.submit-result-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ad-submit {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  padding: 12px 32px;
  text-align: right;
  background: #fff;
  border-top: 1px solid #eaeaea;
}
</style>
